const YesNoNode = require('../YesNoNode');
const BattleCalc = require('../../BattleCalc');
const Q_injury_nearby = require('./Q_injury_nearby');
const UseAbility = require('../UseAbility');
const AICalc = require('../AICalc');

const Q_injured_ally_cluster = function (actor, battleState, buffNode) {
  const node = new YesNoNode(actor, battleState);

  node.sanctuary = BattleCalc.getEquippedAbility(actor, 'sanctuary');

  node.branches[node.NO] = new Q_injury_nearby(actor, battleState, buffNode);

  if (node.sanctuary) {
    node.branches[node.YES] = new UseAbility({
      actor,
      abilityHandle: 'sanctuary',
      altNode: node.branches[node.NO],
    });
  } else {
    node.branches[node.YES] = node.branches[node.NO];
  }

  const originalDispose = node.dispose;
  node.dispose = function() {
    node.sanctuary = null;
    originalDispose.call(node);
  };

  node.yesNoEvalFunction = function (target) {
    if (!this.battleState) {
      return null;
    }

    const getNumClusteredInjuries = (target) => {
      let numInjured = 0;
      let allies = BattleCalc.getAlliesOfUnit(
        target,
        this.battleState.allUnits,
        true,
        false // never heal summons
      );

      for (const ally of allies) {
        if (
          BattleCalc.boardDistance(ally, target) <=
            this.sanctuary.effectRange &&
          BattleCalc.unitHPBelowPercent(
            ally,
            AICalc.SUPPORT_DECISION_LOW_HP_THRESHOLD
          )
        ) {
          ++numInjured;
        }
      }

      return numInjured;
    };

    return this.sanctuary && getNumClusteredInjuries(target) >= 2;
  };

  return node;
};
module.exports = Q_injured_ally_cluster;
